<template>
  <div class="personal">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div v-if="pageType == 'app'" class="dv_list">
          <ul>
            <li @click="goAccOverview">
              <div class="item">
                <span>个人资料</span>
                <p>
                  <em><img src="@/assets/images/template/user_arrow.png"></em>
                </p>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="isPrompt" class="prompt">
          <span>温馨提示：保障您的资金安全，请手持身份证验证身份信息</span>
        </div>
        <div class="dv_list">
          <ul>
            <li @click="goIdentity">
              <div class="item">
                <span>证件照片</span>
                <p :class="colorStatus(identityStatus)">
                  <span class="status" :class="colorStatus(identityStatus)">
                    {{ identityTxt }}
                  </span>
                  <em><img
                    v-if="identityStatus == 0 || identityStatus == 2"
                    src="@/assets/images/template/user_arrow.png"
                  ></em>
                </p>
              </div>
              <div v-if="isShow" class="item">
                <p v-if="identityStatus != 3" class="color" :class="colorStatus(identityStatus)">
                  {{ identityReason || "上传手持身份证照片认证" }}
                </p>
              </div>
            </li>
            <li @click="goBankProof">
              <div class="item">
                <span>银行卡管理</span>
                <p :class="colorStatus(bankProofStatus)">
                  <span class="status" :class="colorStatus(bankProofStatus)">
                    {{ bankProofTxt }}
                  </span>
                  <em><img
                    v-if="
                      bankProofStatus == 0 ||
                        bankProofStatus == 2 ||
                        bankProofStatus == 3
                    "
                    src="@/assets/images/template/user_arrow.png"
                  ></em>
                </p>
              </div>
              <div v-if="isShow" class="item">
                <p v-if="bankProofStatus != 3" class="color" :class="colorStatus(bankProofStatus)">
                  {{ bankProofReason || "上传本人银行卡证明文件" }}
                </p>
              </div>
            </li>
            <li v-if="isAddress" @click="goAddress">
              <div class="item">
                <span>地址证明</span>
                <p :class="colorStatus(addressStatus)">
                  {{ addressTxt
                  }}<em><img
                    v-if="addressStatus == 0 || addressStatus == 2"
                    src="@/assets/images/template/user_arrow.png"
                  ></em>
                </p>
              </div>
              <div v-if="isShow" class="item">
                <p v-if="addressStatus != 3" class="color">上传地址证明文件</p>
              </div>
            </li>
            <li v-if="isCredentials" @click="goCredentials">
              <div class="item">
                <span>手持证件照</span>
                <p :class="colorStatus(credentialsStatus)">
                  {{ credentialsTxt
                  }}<em><img
                    v-if="credentialsStatus == 0 || credentialsStatus == 2"
                    src="@/assets/images/template/user_arrow.png"
                  ></em>
                </p>
              </div>
              <div v-if="isShow" class="item">
                <p v-if="credentialsStatus != 3" class="color">
                  上传本人手持证件照文件
                </p>
              </div>
            </li>
            <li
              v-if="withdrawMethod.usdt"
              @click="goEwalletList"
            >
              <div class="item">
                <span>电子钱包</span>
                <p>
                  <em><img src="@/assets/images/template/user_arrow.png"></em>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <Chat />
    </div>
    <!--是否有银行卡-->
    <div v-if="isHasBank" class="popFixed">
      <div class="masking" @click="closeBankPop" />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p class="txtLeft">
            您已绑定了{{ bankNum }}张银行卡，可优先上传证明文件
          </p>
        </div>
        <div class="itemBank">
          <div
            v-for="(item, index) in bankList"
            :key="'registered-bank-' + index"
            class="bankList"
            :class="{ checked: isCheck == index }"
            @click="checkBank(index, item.bankOrder)"
          >
            <span><em />{{ item.bankName }}</span>
            <p>
              {{
                maskBankAccountNumber(item.bankAccountNumber)
              }}
            </p>
          </div>
        </div>
        <div
          class="btnCon upDown"
          :class="bankList && bankList.length < 3 ? '' : 'only'"
        >
          <span @click="goUploadProof(bankOrder)">去上传</span>
          <span
            v-if="bankList && bankList.length < 3"
            @click="goAddBankCard"
          >添加新卡</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/personal.css')
import Header from '@/view/module/Header.vue'
import Chat from '@/view/module/Chat.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
import { maskBankAccountNumber } from '@/utils/helper'

export default {
  name: 'PersonalInfo',
  components: { Header, Chat },
  data() {
    return {
      title: '个人信息',
      isHasBank: false,
      rightContent: 'isNo',
      isShow: false,
      identityStatus: -1, // 证件照片
      isIdentity: false,
      identityTxt: '',
      identityReason: '',
      bankProofStatus: -1, // 银行卡证明
      isBankProof: false,
      bankProofTxt: '',
      bankProofReason: '',
      addressStatus: -1, // 地址证明
      isAddress: false,
      addressTxt: '',
      credentialsStatus: -1, // 手持证件照
      isCredentials: false,
      credentialsTxt: '',
      bankNum: '', // 取款银行卡数
      bankList: [],
      isCheck: 0,
      bankOrder: '', // 选择银行卡上传文件信息
      isPrompt: false,
      withdrawMethod: {
        usdt: false,
        bank: true
      }
    }
  },
  computed: {
    ...mapState(['pageType', 'token', 'accountInfo'])
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.certifyInfo()
    this.labelAuthority()
    this.AuthInfo()
    this.getWithdrawBankList()
    this.getWithdrawMethod()
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    goAccOverview() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/accOverview' })
    },
    certifyInfo() {
      api.getCertifyInfo().then((res) => {
        if (res.status) {
          if (res.data.code == 200) {
            // if (res.data.data) this.isPrompt = false
            // else this.isPrompt = true
          }
        }
      })
    },
    labelAuthority() {
      api.getLabelAuthority().then((res) => {
        if (res.status) {
          if (res.data.code == 200) {
            const data = res.data.data
            this.isIdentity = data.verifyIdBankCard // 证件照片
            this.isBankProof = data.cashoutCardProof // 取款银行(卡)证明
            this.isAddress = data.residenceProof // 地址证明
            this.isCredentials = data.handheldIdPhoto // 手持证件照
          }
        }
      })
    },
    AuthInfo() {
      api.getAuthInfo().then((res) => {
        if (res.status) {
          if (res.data.code == 200) {
            this.isShow = true
            const identity = res.data.data.FILE_TYPE_IDCARD.status
            const bankProof = res.data.data.FILE_TYPE_BANK.status
            const address = res.data.data.FILE_TYPE_ADDRESS.status
            const credentials = res.data.data.FILE_TYPE_OTHER_2.status
            if (identity === 'EMPTY') {
              this.identityStatus = 0
              this.identityTxt = '未上传'
              this.isPrompt = true
            } else if (identity === 'PRE_APPROVAL') {
              this.identityStatus = 1
              this.identityTxt = '待审核'
              this.isPrompt = true
            } else if (identity === 'CANCEL') {
              this.identityStatus = 2
              this.identityTxt ='审核失败'
              this.identityReason = res.data.data.FILE_TYPE_IDCARD.reason
              this.isPrompt = true
            } else if (identity === 'APPROVAL') {
              this.identityStatus = 3
              this.identityTxt = '审批通过'
              this.isPrompt = false
            }
            if (bankProof === 'EMPTY') {
              this.bankProofStatus = 0
              this.bankProofText = '未上传'
            } else if (bankProof === 'PRE_APPROVAL') {
              this.bankProofStatus = 1
              this.bankProofTxt = '待审核'
            } else if (bankProof === 'CANCEL') {
              this.bankProofStatus = 2
              this.bankProofTxt = '审核失败'
              this.bankProofReason = res.data.data.FILE_TYPE_BANK.reason
            } else if (bankProof === 'APPROVAL') {
              this.bankProofStatus = 3
              this.bankProofTxt = ''
            }
            if (address === 'EMPTY') {
              this.addressStatus = 0
              this.addressTxt = '未上传'
            } else if (address === 'PRE_APPROVAL') {
              this.addressStatus = 1
              this.addressTxt = '待审核'
            } else if (address === 'CANCEL') {
              this.addressStatus = 2
              this.addressTxt = '审核失败'
            } else if (address === 'APPROVAL') {
              this.addressStatus = 3
              this.addressTxt = '审批通过'
            }
            if (credentials === 'EMPTY') {
              this.credentialsStatus = 0
              this.credentialsTxt = '未上传'
            } else if (credentials === 'PRE_APPROVAL') {
              this.credentialsStatus = 1
              this.credentialsTxt = '待审核'
            } else if (credentials === 'CANCEL') {
              this.credentialsStatus = 2
              this.credentialsTxt = '审核失败'
            } else if (credentials === 'APPROVAL') {
              this.credentialsStatus = 3
              this.credentialsTxt = '审批通过'
            }
          }
        }
      })
    },
    goIdentity() {
      if (this.identityStatus == 0 || this.identityStatus == 2) {
        this.$bus.$emit('loading', false)
        this.$router.push({ path: '/home/identity' })
      }
    },
    closeBankPop() {
      this.toggleFixed()
      this.isHasBank = !this.isHasBank
    },
    checkBank(num, obj) {
      this.isCheck = num
      this.bankOrder = obj
    },
    goUploadProof(obj) {
      this.$bus.$emit('loading', false)
      this.$router.push({
        path: '/home/uploadProof',
        query: { bankOrder: obj }
      })
    },
    goAddBankCard() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/addBankCard', query: { bankType: 0 }})
    },
    goBankProof() {
      if (this.bankProofStatus == 0 || this.bankProofStatus == 2) {
        if (this.bankList.length == 0) {
          this.$bus.$emit('loading', false)
          this.$router.push({
            path: '/home/addBankCard',
            query: { bankType: 0 }
          })
        } else {
          this.toggleFixed()
          this.isHasBank = !this.isHasBank
        }
      } else if (this.bankProofStatus == 3) {
        this.$bus.$emit('loading', false)
        this.$store.dispatch('setTabIndex', 0)
        this.$router.push({ path: '/home/bankList' })
      }
    },
    goAddress() {
      if (this.addressStatus == 0 || this.addressStatus == 2) {
        this.$bus.$emit('loading', false)
        this.$router.push({ path: '/home/address' })
      }
    },
    goCredentials() {
      if (this.credentialsStatus == 0 || this.credentialsStatus == 2) {
        this.$bus.$emit('loading', false)
        this.$router.push({ path: '/home/credentials' })
      }
    },
    goEwalletList() {
      this.$router.push({ path: '/home/eWalletList' })
    },
    colorStatus(obj) {
      let val
      if (obj == 1) {
        val = 'processing'
      } else if (obj == 2) {
        val = 'fail'
      } else val = ''
      return val
    },
    getWithdrawBankList() {
      api.getWithdrawBankList().then((res) => {
        if (res.status) {
          if (res.data.code == 200) {
            if (res.data.data.withdrawBankList) {
              const arrData = []
              const list = res.data.data.withdrawBankList
              for (const i in list) {
                if (
                  list[i].approveStatus == 'CANCEL' ||
                  list[i].approveStatus == 'EMPTY'
                ) {
                  arrData.push(list[i])
                }
              }
              this.bankList = arrData
              if (this.bankList.length > 0) {
                this.bankOrder = this.bankList[0].bankOrder
                if (this.bankList.length == 1) {
                  this.bankNum = '一'
                } else if (this.bankList.length == 2) {
                  this.bankNum = '二'
                } else if (this.bankList.length == 3) {
                  this.bankNum = '三'
                }
              }
            }
          }
        }
      })
    },
    getWithdrawMethod() {
      if (this.accountInfo.cashoutTag) {
        const tag = this.accountInfo.cashoutTag
        if (tag === 'X1') {
          this.withdrawMethod.usdt = true
        } else if (tag === 'X2') {
          this.withdrawMethod.usdt = true
          this.withdrawMethod.bank = true
        }
      }
    },
    maskBankAccountNumber
  }
}
</script>
